<script>
import ExecutionDetail from '@/components/execution/ExecutionDetail.vue'
import axios from 'axios'
import moment from 'moment/moment'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
export default {
  name: 'ExecutionFocus',
  components: {
    ExecutionDetail
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  data: () => ({
    execution: null,
    executionLoader: false,
    showId: false
  }),
  mounted() {
    this.getSelectedFromRoute()
  },
  watch: {
    $route(to, from) {
      this.getSelectedFromRoute()
    }
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    goToExecutionList() {
      this.$router.push({ name: 'executions' })
    },
    refresh() {
      this.executionLoader = true
      axios
        .get(
          `/api/v1/executions/${this.$route.params.hexId}?projection=withReferenceHexId`
        )
        .then(response => {
          this.execution = response.data
          this.executionLoader = false
        })
        .catch(error => {
          console.log(error)
          this.executionLoader = false
          this.$router.replace({ name: 'executions' })
        })
    },
    //   Get execution id from route
    getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'execution') {
        this.refresh()
      } else {
        this.$router.replace({ name: 'executions' })
      }
    }
  }
}
</script>

<template>
  <div>
    <v-progress-linear color="accent" indeterminate v-if="executionLoader">
    </v-progress-linear>
    <v-card style="border-radius: 10px">
      <v-toolbar flat dense>
        <span class="beez-bold">Execution Details</span>
        <v-spacer></v-spacer>
        <v-chip outline v-if="execution && execution.hexId"
          ><span
            :class="
              execution.runStatus === 'FAILED'
                ? 'red--text body-1 font-weight-bold'
                : execution.runStatus === 'OBSOLETE'
                ? 'grey--text body-1 font-weight-bold'
                : 'green--text body-1 font-weight-bold'
            "
            >{{ format(execution.runStatus) }}</span
          ></v-chip
        >
        <v-btn
          class="text-capitalize"
          flat
          outline
          v-if="execution && execution.executionType === 'WORKFLOW'"
          @click.stop="showId = !showId"
          >{{ showId ? 'Hide Execution ID' : 'Show Execution ID' }}
        </v-btn>
        <v-tooltip bottom>
          <v-btn slot="activator" flat icon @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" flat icon @click="goToExecutionList">
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
          <span>Goto Execution List</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <div v-if="execution && execution.hexId">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Execution Id</div>
                  <div class="subheading">
                    {{ execution.hexId }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Execution Type</div>
                  <div class="subheading">
                    {{ format(execution.executionType) }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Executed As</div>
                  <div class="subheading">
                    {{ format(execution.executedAs) }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Service name</div>
                  <div class="subheading">
                    {{
                      execution.executionType === 'BOT'
                        ? execution.botName
                        : execution.workflowName
                    }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Service Description</div>
                  <div class="subheading">
                    {{
                      execution.executionType === 'BOT'
                        ? execution.botDescription
                        : execution.workflowDescription
                    }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Started By</div>
                  <div class="subheading">
                    {{ execution.requestedByName }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Started At</div>
                  <div class="subheading">
                    {{ getLocalTime(execution.createdAt) }}
                  </div>
                  <br />
                </div>
              </v-flex>
              <v-flex xs12 md6 lg4 xl3>
                <div class="text-xs-left">
                  <br />
                  <div>Completed At</div>
                  <div class="subheading" v-if="execution.completedAt">
                    {{ getLocalTime(execution.completedAt) }}
                  </div>
                  <br />
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <execution-detail
            v-if="execution && execution.hexId"
            :execution="execution"
            :show-id="showId"
          />
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped></style>
